module.exports = __webpack_public_path__ + "static/badge-canada-150x150-38c431386370d677900607bf3f9ba6df.png";